import useMediaQuery from "@mui/material/useMediaQuery";

export const useMediaQueries = () => {
  const to366 = useMediaQuery("(max-width: 366px)", { noSsr: true });
  const toSm = useMediaQuery("(max-width: 599px)", { noSsr: true });
  const fromSm = useMediaQuery("(min-width: 600px)", { noSsr: true });
  const toMd = useMediaQuery("(max-width: 839px)", { noSsr: true });
  const fromMd = useMediaQuery("(min-width: 840px)", { noSsr: true });
  const to899 = useMediaQuery("(max-width: 899px)", { noSsr: true });
  const from899 = useMediaQuery("(min-width: 899px)", { noSsr: true });
  const toLg = useMediaQuery("(max-width: 1439px)", { noSsr: true });
  const fromLg = useMediaQuery("(min-width: 1440px)", { noSsr: true });
  const to939 = useMediaQuery("(max-width: 939px)", { noSsr: true });
  const to1099 = useMediaQuery("(max-width: 1099.95px)", { noSsr: true });
  const from1099 = useMediaQuery("(min-width: 1099.95px)", { noSsr: true });
  const to1600 = useMediaQuery("(max-width: 1599px)", { noSsr: true });
  const from1600 = useMediaQuery("(min-width: 1600px)", { noSsr: true });
  const to1920 = useMediaQuery("(max-width: 1920px)", { noSsr: true });
  const from1920 = useMediaQuery("(min-width: 1920px)", { noSsr: true });
  return {
    to366,
    fromSm,
    toSm,
    toMd,
    fromMd,
    to899,
    from899,
    fromLg,
    toLg,
    to939,
    to1099,
    from1099,
    to1600,
    from1600,
    to1920,
    from1920
  };
};
